import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { Colors } from "../../config/Constants";

type ImageModalProps = {
  onClose: () => void;
  open: boolean;
  imageLink: string;
};

const ImageModal = ({ open, onClose, imageLink }: ImageModalProps) => {
  
  const useOutsideAlerter = (ref: any) => {
    useEffect(() => {
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          onClose();
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };
  const modalWrapperRef = useRef(null);

  useOutsideAlerter(modalWrapperRef);

  return (
    <>
      {open && (
        <ModalBackground>
          <ImageContainer ref={modalWrapperRef}>
            <Close
              src={require("../../assets/images/ei_close.png")}
              alt="close"
              onClick={onClose}
            />
            <Image src={imageLink} alt="modalImage" />
          </ImageContainer>
        </ModalBackground>
      )}
    </>
  );
};

const ModalBackground = styled.div`
  background: ${Colors.emperorApprox}80;
  height: 100vh;
  width: 100vw;
  position: absolute;
  z-index: 999;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Close = styled.img`
  cursor: pointer;
  position: absolute;
  right: -1.5rem;
  top: -1.5rem;
`;

const ImageContainer = styled.div`
  width: 40%;
  position: relative;
  @media only screen and (max-width: 768px) {
    width: 80%;
  }
`;

const Image = styled.img`
  height: 100%;
  width: 100%;
`;

export default ImageModal;
